module.exports = __webpack_public_path__ + "img/icon-pp.76507e06.webp";